





































































































































































import { Component, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { SystemCode } from '@/api'
import { systemCodeStore } from '@/utils/store-accessor'

export interface InputEditNoteItem {
  workMemo: {
    input: string
    code: string
    time: string
    place: string
    errorMessage: string
  }
  displayMemo: {
    input: string
    code: string
    time: string
    place: string
    errorMessage: string
  }
  localMemo: {
    input: string
    code: string
    time: string
    place: string
    errorMessage: string
  }
}

export const defaultInputEditNoteItem = (): InputEditNoteItem => ({
  workMemo: {
    input: '',
    code: '',
    time: '',
    place: '',
    errorMessage: ''
  },
  displayMemo: {
    input: '',
    code: '',
    time: '',
    place: '',
    errorMessage: ''
  },
  localMemo: {
    input: '',
    code: '',
    time: '',
    place: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCode
  }
})
export default class CollectionEditLendAndOtherNote extends ComponentVue {
  @Ref()
  workMemoInputCode!: InputCode

  @Ref()
  displayMemoInputCode!: InputCode

  @Ref()
  localMemoInputCode!: InputCode

  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputEditNoteItem

  get exclusionCodesByWorkMemo(): string[] {
    return systemCodeStore.exclusionCodesByWorkMemo
  }

  get exclusionCodesByDisplayMemo(): string[] {
    return systemCodeStore.exclusionCodesByDisplayMemo
  }

  get exclusionCodesByLocalMemo(): string[] {
    return systemCodeStore.exclusionCodesByLocalMemo
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  onClickWorkMemoEraser(): void {
    this.inputItem.workMemo.input = ''
    this.inputItem.workMemo.code = ''
    this.inputItem.workMemo.time = ''
    this.inputItem.workMemo.place = ''
    this.workMemoInputCode.textField.atomTextField.focus()
  }

  onClickDisplayMemoEraser(): void {
    this.inputItem.displayMemo.input = ''
    this.inputItem.displayMemo.code = ''
    this.inputItem.displayMemo.time = ''
    this.inputItem.displayMemo.place = ''
    this.displayMemoInputCode.textField.atomTextField.focus()
  }

  onClickLocalMemoEraser(): void {
    this.inputItem.localMemo.input = ''
    this.inputItem.localMemo.code = ''
    this.inputItem.localMemo.time = ''
    this.inputItem.localMemo.place = ''
    this.localMemoInputCode.textField.atomTextField.focus()
  }

  onInputWorkMemoCode(systemCode: SystemCode): void {
    this.inputItem.workMemo.input = systemCode.shortName
  }

  onInputDisplayMemoCode(systemCode: SystemCode): void {
    this.inputItem.displayMemo.input = systemCode.shortName
  }

  onInputLocalMemoCode(systemCode: SystemCode): void {
    this.inputItem.localMemo.input = systemCode.shortName
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
